export default { sha: '2a8590bbfbd719b12314daa60456f9236689f56b', buildNumber: 'undefined' }
